/*
 * @Author: QZJ
 * @返回一个axios实例，所有ajax统一处理
 * @Date:   2017-09-26 20:19:01
 * @Last Modified by:   QZJ
 * @Last Modified time: 2017-10-08 14:38:01
 */
import axios from 'axios';
import IO from '@/config/api-config';
import App from '@/common/app';
import { debounce, getTime } from '@/common/utils';
import reporter from '@/api/report';
import { Toast } from 'vant';
const DOMAIN = window.location.host;

const httpInstances = axios.create({
  baseURL: `${IO.baseUrl}`,
  timeout: 10000
});

// app登出函数
const logonStateFailure = debounce(App.logonStateFailure, 500);

const report = (config, status = '0') => {
  if (process.env.VUE_APP_BUILD_MODE !== 'production') return false;
  let rqTime = getTime(config.rqTime);
  let data = JSON.parse(config.data);
  const url = config.url.split('?');
  const calleeNode = url[0];
  let params = {
    rqTime: `${rqTime.y}/${rqTime.m}/${rqTime.d}+${rqTime.h}:${rqTime.M}`,
    useTime: Date.now() - config.rqTime,
    calleeNode,
    methods: data._head ? data._head._interface : '',
    status,
    callerNode: DOMAIN
  };
  if (Number(params.useTime) > 10000) params.useTime = '10000';
  reporter.action(params);
};

httpInstances.interceptors.request.use(config => {
  config.rqTime = Date.now();
  return config;
});

httpInstances.interceptors.response.use(
  response => {
    return new Promise((resolve, reject) => {
      const result = response.data._data;
      let config = response.config;
      let status = result._ret ? result._ret : 'no-ret';
      const _interface = JSON.parse(config.data)._head._interface || '';
      report(config, status);
      reporter.logs(response);
      if (
        (result._ret && Number(result._ret) !== 0) ||
        (result._errCode && Number(result._errCode) !== 0)
      ) {
        // 冗余请求，失败不做其他处理
        if (_interface === 'get_store_info') {
          return reject(result);
        }
        /**
         * 登录状态错误
         * 10007 其他地方登录
         * 7777 用户信息改变
         * 10006 登录信息过期
         * 抛给App统一处理
         */
        if (
          result._errCode === 'XIANYU-FACADE-10007' ||
          result._errCode === 'XIANYU-FACADE-7777' ||
          result._errCode === 'XIANYU-FACADE-10006'
        ) {
          logonStateFailure(result._errCode);
          return reject(result);
        }
        Toast(result._errStr || '后台开小差～');
        return reject(result);
      }
      resolve(result);
    });
  },
  error => {
    console.log('error', error.config, error.response, error.message);
    if(error && error.message === '取消请求')return
    let config = error.config;
    let status =
      (error.response && error.response.status) ||
      error.message.replace(/\s/g, '+');
    report(config, status);
    reporter.logs(error);
    Toast('网络异常！');
    Promise.reject(error.message || '网络异常！');
  }
);
export default httpInstances;
